import { render, staticRenderFns } from "./TransferOrderDetail.vue?vue&type=template&id=318b864b"
import script from "./TransferOrderDetail.vue?vue&type=script&lang=js"
export * from "./TransferOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('318b864b')) {
      api.createRecord('318b864b', component.options)
    } else {
      api.reload('318b864b', component.options)
    }
    module.hot.accept("./TransferOrderDetail.vue?vue&type=template&id=318b864b", function () {
      api.rerender('318b864b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/transfer/TransferOrderDetail.vue"
export default component.exports